import React from 'react';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import ThirdStep from './ThirdStep';
import {Col, Button} from 'react-bootstrap';

function getStepContent(step, saveTopState, readTopState ) {
  switch (step) {
    case 0:
      return <FirstStep saveTopState={saveTopState} readTopState={readTopState} />;
    case 1:
      return <SecondStep saveTopState={saveTopState} readTopState={readTopState}  />;
    case 2:
      return <ThirdStep saveTopState={saveTopState} readTopState={readTopState}  />;
    default:
      throw new Error('Unknown step');
  }
}

class QuoteCalc extends React.Component {
  state = {
    activeStep: 0,
  };

  handleNext = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  };

  handleBack = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
    });
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  render() {
    const { saveTopState, readTopState } = this.props;
    return (
      <div className="quote-calculator-x-inner">
        <form id="calcForm">
          {getStepContent(readTopState('activeStep'), saveTopState, readTopState)}
          <Col xs={6} className="steps-navigation no-need">
            { this.state.activeStep > 10 ? <Button bsStyle="primary" bsSize="large" onClick={this.handleBack}>Prev Step</Button> : null }
            { this.state.activeStep < 0 ?<Button bsStyle="primary" bsSize="large" onClick={this.handleNext}>Next Step</Button> : null }
              
          </Col>  
        </form>
      </div>
    );
  }
}

// QuoteCalc.propTypes = {
//   classes: PropTypes.object.isRequired,
// };

export default QuoteCalc;



// WEBPACK FOOTER //
// ./src/steps/Steps.js